import React, { useEffect, useState } from "react";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import { useNavigate, useParams } from "react-router-dom";
import ErrorAlert from "../components/ErrorAlert";
import SuccessAlert from "../components/SuccessAlert";

export default function UpdateBooking() {
  const { bookingId } = useParams();
  const navigate = useNavigate();

  // State Handling
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [bookingData, setBookingData] = useState();
  const [loading, setLoading] = useState(false);

  // Get Bookings's Data
  const getBookingData = async () => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/booking/${bookingId}`
    );
    const result = await response.json();

    if (response.ok) {
      setBookingData(result);
    }
  };

  useEffect(() => {
    getBookingData();
  }, []);

  // Form Submission To Update Booking In DataBase
  const updateBookingsSubmitHandler = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setLoading(true);

    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/edit-booking/${bookingId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bookingData),
        }
      );
      const result = await response.json();

      if (response.ok) {
        setSuccess("Booking Updated!");
        setTimeout(() => {
          navigate("/admin/all-bookings");
        }, 1000);
      } else if (!response.ok) {
        setError("Update Failed! Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Updating Booking</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        {success && <SuccessAlert successMsg={success} />}
        {error && <ErrorAlert errorMsg={error} />}
        {/* Showing Alert based on http request response End */}

        {/* Update Booking Heading Start */}
        <AdminPanelGeneralHeading text="Update Booking" />
        {/*Update Place Heading End */}

        {/* Update Booking Form Start */}
        <div className="col-12 add-places-form-cover signup-form-cover">
          <form className="p-0" onSubmit={updateBookingsSubmitHandler}>
            {/* Row 1 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <label className="form-label">Booking Status</label>
                <select
                  name="booking_status"
                  className="form-control"
                  required
                  value={bookingData?.booking_status}
                  onChange={(e) => {
                    setBookingData({
                      ...bookingData,
                      booking_status: e.target.value,
                    });
                  }}
                >
                  <option value={bookingData?.booking_status}>
                    {bookingData?.booking_status}
                  </option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Expired">Expired</option>
                </select>
              </div>
            </div>

            {/* Row 2 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <label className="form-label">Created At</label>
                <input
                  type="text"
                  name="booking_created_at"
                  required
                  className="form-control"
                  value={bookingData?.createdAt?.split("T")[0]}
                />
              </div>
              <div className="col p-0 signup-col">
                <label className="form-label">Last Updated At</label>

                <input
                  type="text"
                  name="booking_updated_at"
                  required
                  className="form-control"
                  value={bookingData?.updatedAt?.split("T")[0]}
                />
              </div>
            </div>

            {/* Submit Btn */}
            <button
              type="submit"
              className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
            >
              Update Booking
            </button>
          </form>
        </div>
        {/* Update Booking Form End */}
      </>
    );
}
